import React from 'react';
import RoundCheckbox from './components/RoundCheckbox';
import RefundItemAccordion from './components/RefundItemAccordion';
import styles from "../../styles.module.scss";
import { formattedPrice } from '../../../../../../views/pages/manage/unAssigned/collectPayment/utils';
import { FULL_REFUND } from '../../utils';
import SubTypeRefundDetailsForm from './components/SubTypeRefundDetailsForm';
import AButton from '../../../../../../views/pages/manage/common/form-fields-mui/AButton';
import CrossIcon from "assets/img/svg/svgComponents/CrossIcon";
import DownloadSupportingDoc from './components/DownloadSupportingDoc';


const FullRefund = ({
    payableRefundInfo,
    selectedRefundItems,
    refundItemCheckboxHandler,
    refundDetailsForm,
    handleRefundDetailsForm,
    isConcessionRefund,
    viewOnly,
    refundReasons,
    isLoanCase,
    setSelectedRefundItems,
    setShowFullRefundItem,
    setLoading,
    forRefundEdit
}) => {

    const isDisabled = isConcessionRefund;

    const { totalRefundableAmount } = payableRefundInfo?.[FULL_REFUND] ?? {};

    const isSelected = selectedRefundItems?.includes(FULL_REFUND);

    const enableItemSelection = !viewOnly && !forRefundEdit;

    const removeFullRefund = e => {
        e.stopPropagation();
        setShowFullRefundItem(false);
        setSelectedRefundItems([]);
    }

    return (
        <RefundItemAccordion
            isDisabled={isDisabled}
        >

            <div className='d-flex align-items-center justify-content-between'>
                <div className='d-flex align-items-center'>

                    {
                        enableItemSelection &&
                        <RoundCheckbox
                            isChecked={isSelected}
                            onChange={(checked) => refundItemCheckboxHandler(FULL_REFUND, checked, true)}
                            isDisabled={isDisabled}
                        />
                    }

                    <div className={`${styles['accordion-title']} mr-1`}>Full Refund •</div>

                    <div className={`${styles['amount']}`}>{formattedPrice(totalRefundableAmount)}</div>
                                    <div className='d-flex ml-auto'>
                    <DownloadSupportingDoc
                        isDisabled={isDisabled}
                        isSelected={isSelected}
                        refundDetailsForm={refundDetailsForm}
                        refundSubType={FULL_REFUND}
                        isLoanCase={isLoanCase}
                        setLoading={setLoading}
                    />

                </div>
                </div>

                {enableItemSelection && <AButton
                    variant='outline_danger'
                    size='xs'
                    onClick={removeFullRefund}
                >
                    Remove
                    <span className='ml-2'><CrossIcon color={"#DC2804"} /></span>
                </AButton>}

            </div>


            <SubTypeRefundDetailsForm
                refundItemName={FULL_REFUND}
                form={refundDetailsForm}
                formHandler={handleRefundDetailsForm}
                amountFieldRequired
                maxRefundAmount={totalRefundableAmount}
                isDisabled={(isDisabled || !isSelected || viewOnly)}
                reasonsDropdownData={refundReasons?.[FULL_REFUND]}
                isLoanCase={isLoanCase}
            />

        </RefundItemAccordion>

    );
}

export default FullRefund;